import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddProject from '../AddProject';
import SearchProjectCreation from '../EmployerInvitesConsultantToProjectModal/SearchProjectCreation';
import '../EmployerInvitesConsultantToProjectModal/EmployerInvitesConsultantToProjectModal.scss';
var HireAgain = /*#__PURE__*/function (_Component) {
  function HireAgain(props) {
    var _this;
    _classCallCheck(this, HireAgain);
    _this = _callSuper(this, HireAgain, [props]);
    _this.state = {
      currentPage: 'add'
    };
    _this.setCurrentPageToCreateNew = _this.setCurrentPageToCreateNew.bind(_this);
    _this.setCurrentPageToAddProject = _this.setCurrentPageToAddProject.bind(_this);
    _this.afterProjectCreation = _this.afterProjectCreation.bind(_this);
    return _this;
  }
  _inherits(HireAgain, _Component);
  return _createClass(HireAgain, [{
    key: "setCurrentPageToCreateNew",
    value: function setCurrentPageToCreateNew() {
      this.setState({
        currentPage: 'create'
      });
    }
  }, {
    key: "setCurrentPageToAddProject",
    value: function setCurrentPageToAddProject() {
      this.setState({
        currentPage: 'add'
      });
    }
  }, {
    key: "afterProjectCreation",
    value: function afterProjectCreation(projectResourceId) {
      var newUrl = "/projects/".concat(projectResourceId);
      window.location.href = newUrl; // go to newly created project page.
    }
  }, {
    key: "renderPage",
    value: function renderPage() {
      var _this2 = this;
      var _this$props = this.props,
        consultant = _this$props.consultant,
        projectsToDuplicate = _this$props.projectsToDuplicate,
        durationOptions = _this$props.durationOptions,
        timePerWeekOptions = _this$props.timePerWeekOptions,
        workLocationOptions = _this$props.workLocationOptions,
        companyId = _this$props.companyId,
        csrfToken = _this$props.csrfToken,
        isRep = _this$props.isRep,
        projectTemplates = _this$props.projectTemplates;
      var currentPage = this.state.currentPage;
      if (currentPage === 'add') {
        return /*#__PURE__*/React.createElement("div", {
          className: "projects-add_project"
        }, /*#__PURE__*/React.createElement(AddProject, {
          projects: projectsToDuplicate,
          consultant: consultant,
          hireAgain: true,
          onCreateNewProject: function onCreateNewProject() {
            return _this2.setCurrentPageToCreateNew();
          },
          projectTemplates: projectTemplates,
          csrfToken: csrfToken
        }));
      }
      if (currentPage === 'create') {
        return /*#__PURE__*/React.createElement("div", {
          className: "style-guide employer-invites-consultant-to-project"
        }, /*#__PURE__*/React.createElement("div", {
          className: "modal-body"
        }, /*#__PURE__*/React.createElement(SearchProjectCreation, {
          hireAgain: true,
          backToProjectSelection: function backToProjectSelection() {
            return _this2.setCurrentPageToAddProject();
          },
          companyId: companyId,
          isRep: isRep,
          consultant: consultant,
          workLocationOptions: workLocationOptions,
          durationOptions: durationOptions,
          timePerWeekOptions: timePerWeekOptions,
          csrfToken: csrfToken,
          handleInvited: function handleInvited(newProjectResId) {
            return _this2.afterProjectCreation(newProjectResId);
          }
        })));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderPage());
    }
  }]);
}(Component);
HireAgain.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  companyId: PropTypes.number,
  isRep: PropTypes.bool.isRequired,
  projectsToDuplicate: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.string)]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.string)]).isRequired,
  projectTemplates: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
HireAgain.defaultProps = {
  companyId: 0
};
export default HireAgain;